export interface FileChunkDescriptor {
  partNumber: number;
  start: number;
  end: number;
  size: number;
}

export const buildFileChunks = (
  fileSize: number,
  partSize: number
): FileChunkDescriptor[] => {
  if (fileSize <= 0 || partSize <= 0) {
    return [];
  }

  const chunks: FileChunkDescriptor[] = [];
  let partNumber = 1;

  for (let start = 0; start < fileSize; start += partSize) {
    const end = Math.min(start + partSize, fileSize);

    chunks.push({
      partNumber,
      start,
      end,
      size: end - start,
    });

    partNumber += 1;
  }

  return chunks;
};

export const getFileChunk = (file: File, chunk: FileChunkDescriptor) =>
  file.slice(chunk.start, chunk.end);
